// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { setData, getData, delData } from '@/util/util.js'

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

//引入vuex
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    tab: 'first',
    tabStatus: 0,
    tab2Status: 0,
    lifeTitle: getData('lifeTitle') ? getData('lifeTitle'): '',
    isLife: getData('isLife') ? Number(getData('isLife')): 1, //是否为生活缴费
    code: getData('code') ? getData('code'): '',
    encryArray: getData('encryArray') ? getData('encryArray'): [], //加密货币类型列表
    encryOrder: getData('encryOrder') ? getData('encryOrder'): {}, //加密货币下单信息
    encryDetail: getData('encryDetail') ? getData('encryDetail'): {}, //下单的加密货币信息
    orderTips: getData('orderTips') ? getData('orderTips'): '', //下单提示
    rechargeCategory: getData('rechargeCategory') ? getData('rechargeCategory'): [], //生活缴费菜单列表
    balanceRules: getData('balanceRules') ? getData('balanceRules'): [] //钱包余额充值选择列表
  },
  mutations: {
    setTab (state, data) {
      state.tab = data;
    },
    setTabStatus (state, data) {
      state.tabStatus = data;
    },
    setTab2Status (state, data) {
      state.tab2Status = data;
    },
    setLifeTitle(state, title) {
      state.lifeTitle = title
      setData('lifeTitle', title)
    },
    setIsLife(state, val) {
      state.isLife = val
      setData('isLife', val)
    },
    setCode(state, code) {
      state.code = code
      setData('code', code)
    },
    setEncryArray(state, encry) {
      state.encryArray = encry
      setData('encryArray', encry)
    },
    setEncryOrder(state, order) {
      state.encryOrder = order
      setData('encryOrder', order)
    },
    setEncryDetail(state, info) {
      state.encryDetail = info
      setData('encryDetail', info)
    },
    setOrderTips(state, val) {
    	state.orderTips = val
    	setData('orderTips', val)
    },
    setRechargeCategory(state, list) {
      state.rechargeCategory = list
      setData('rechargeCategory', list)
    },
    setBalanceRules(state, list) {
      state.balanceRules = list
      setData('balanceRules', list)
    }
  },
  actions: {
    delEncryDetail({ commit }) {
      commit('setEncryDetail', {})
      delData('encryDetail')
    }
  }
})

import VueAwesomeSwiper from 'vue-awesome-swiper'//  全局渲染
import 'swiper/css/swiper.css'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import '../static/less/flex.less'
import App from './App'
import router from './router'
import axios from 'axios'
import Api from './util/Api.js'
// import wxApi from './util/wxapi.js'
import common from '../static/js/common.js'

// 加载更多
import VueLoadmore from 'vuejs-loadmore';
Vue.use(VueLoadmore);
// 加载更多***********end

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// 复制到粘贴板插件***********end

// Vant***********
// import Vant from "vant";
// import "vant/lib/index.css";
// import "vant/lib/index.less";
// window.eventStore = new Vue();
// Vue.use(Vant);
// Vant**************
//导入微信
let wx = require('weixin-js-sdk');
Vue.prototype.wx = wx

// 使用LESS
import less from 'less'
Vue.use(less)

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.prototype.common = common
Vue.prototype.$axios = axios
// Vue.prototype.$wxApi = wxApi

// Vue.use(ElementUI)
// 基础组件的自动化全局注册
// const requireComponent=require.context()
//按需引入element（）
import {Image,InfiniteScroll,Dialog,MessageBox,Button, Select,Input,Tabs,TabPane,Option,Row,Col,Card,Container,Header,Main,Footer,RadioGroup,Radio,Drawer,Message,Loading,PageHeader,Upload } from 'element-ui';
Vue.use(Button)
Vue.use(Dialog)
Vue.use(InfiniteScroll)
Vue.use(PageHeader)
Vue.use(Select)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(Drawer)
Vue.use(TabPane)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Container)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Main)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(Api)
Vue.use(Image)

Vue.use(Loading.directive)

let user_agent = window.navigator.userAgent.toLowerCase();
let client = '';
if (user_agent.match(/magapp/i) == 'magapp') {
  client = 'magapp';
} else if (user_agent.match(/micromessenger/i) == 'micromessenger' && user_agent.match(/micromessenger/i) != 'WindowsWechat') {
  client = 'wxh5';
} else {
  client = 'h5';
}

Vue.prototype.$client = client;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$upload = Upload;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>',
  render:h=>h(App)
})



// WEBPACK FOOTER //
// ./src/main.js